import { inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { ConfigService } from './config.service';
import { UserService } from './user.service';

@Injectable({
	providedIn: 'root'
})
export class SentryService {

	private userService = inject(UserService);
	private configService = inject(ConfigService);

	init(): void {

		Sentry.init({
			beforeSend: (event, hint) => {
				const user = this.userService.getUser();
				if (user) {
					event.user = {
						name: user.name,
						email: user.email
					};
				}
				return event;
			},
			dsn: this.configService.sentryDsn,
			environment: this.configService.environment,
			integrations: [
				Sentry.browserTracingIntegration(),
			],
			tracesSampleRate: 1.0,
		});
	}
} 